import { render, staticRenderFns } from "./CartaoDeObservacoes.vue?vue&type=template&id=8105fb6c&scoped=true"
import script from "./CartaoDeObservacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeObservacoes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeObservacoes.vue?vue&type=style&index=0&id=8105fb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8105fb6c",
  null
  
)

export default component.exports